














































import {
  computed,
  defineComponent,
  onMounted, PropType,
  ref, toRef, useRoute,
  watch,
} from '@nuxtjs/composition-api';

import Collapsible from '~/components/common/Collapsible.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import RatingStars from '~/components/RatingStars/RatingStars.vue';
import { useCompatibleTitle, useProductPageState } from '~/composables';
import useProductTabs, { PRODUCT_TABS } from '~/composables/useProductTabs';
import { smoothScrollToElement } from '~/helpers/smoothScrollToElement';
import { ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductTabs',
  components: {
    RatingStars,
    Collapsible,
    Reviews: () => import('./Reviews/Reviews.vue'),
    Description: () => import('./Description/Description.vue'),
    ReasonsToBuy: () => import('./ReasonsToBuy/ReasonsToBuy.vue'),
    Specification: () => import('~/components/Specification/Specification.vue'),
    Security: () => import('./Security/Security.vue'),
    CompatibilityList: () => import('./CompatibilityList/CompatibilityList.vue'),
    EmptyReviews: () => import('./EmptyReviews/EmptyReviews.vue'),
    SvgImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<ProductInterface | null>,
      default: null,
    },
    closedOnInit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const product = toRef(props, 'product');

    const { activeTab, setActiveTab } = useProductPageState();
    const { compatibleTitle, brandTitle } = useCompatibleTitle(props.product);

    const tabState = ref<string>(props.closedOnInit ? '' : activeTab.value || PRODUCT_TABS.reviews);
    // const showTabContent = ref<boolean>(false);

    const route = useRoute();

    const { tabsConfig } = useProductTabs({
      product, compatibleTitle, brandTitle,
    });

    const currentRating = computed(() => (!props.product.rating_summary ? 0 : +((props.product.rating_summary * 5) / 100).toFixed(1)));
    const tabFromRoute = computed(() => {
      const [, tabAnchor] = route.value.hash.split('#');

      if (tabAnchor && Object.values(PRODUCT_TABS).includes(tabAnchor)) {
        return tabAnchor;
      }

      return '';
    });

    const handleClick = (tabId: string): void => {
      tabState.value = tabId === tabState.value ? '' : tabId;
      smoothScrollToElement(`#${tabId}`);
      setActiveTab(null);
    };

    onMounted(() => {
      if (tabFromRoute.value) {
        tabState.value = tabFromRoute.value;
        const { pathname } = window.location;
        window.history.replaceState(null, '', pathname);
        smoothScrollToElement(`#${tabFromRoute.value}`);
        return;
      }

      // TODO: Try to move outside of mounted
      if (props.closedOnInit) {
        tabState.value = '';
        return;
      }

      if (props.product.review_count > 0) {
        tabState.value = PRODUCT_TABS.reviews;
      } else if (props.product.description) {
        tabState.value = PRODUCT_TABS.description;
      } else {
        tabState.value = PRODUCT_TABS.specification;
      }
    });

    watch(route, () => {
      if (tabFromRoute.value) {
        tabState.value = tabFromRoute.value;
      }
    });

    watch(activeTab, () => {
      if (activeTab.value) {
        tabState.value = activeTab.value;
      }
    });

    return {
      tabsConfig,
      tabState,
      currentRating,
      reviewsTotal: props.product.review_count,
      handleClick,
    };
  },
});
